export default __webpack_public_path__ + "static/media/vecna.507d6ee4.png";